/**
 * Pure sortOrder helpers — no store/model deps so they stay trivially testable.
 */

/**
 * Returns a sortOrder one below the current minimum (or -1 if none).
 * Regular items render by sortOrder asc, so the smallest sorts to the top.
 */
export const nextTopSortOrder = sortOrders =>
  (sortOrders.length ? Math.min(...sortOrders) : 0) - 1
